import Wifi from './Wifi';
import Camera from './Camera';

export default {
  Camera,
  Wifi,
};
